module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp3-02-0b1fda1c55f1d461d2546b732a1021a7.png";